import { hasRequirement } from '../components/AppointmentRequirements/helpers';

export const updateBookingStateRequirement = (bookingState, requirement) => {
    if (hasRequirement(requirement, bookingState.requirements)) {
        const targetRequirement = bookingState.requirements.find(
            req => req.key === requirement
        );
        targetRequirement.value = true;
        return bookingState;
    }
    return bookingState;
};
